import React from 'react';
import { ReactComponent as AppLogoMobileIcon } from '../../assets/signature_logo_solid.svg';

const AppLogoMobile = () => {
  return <AppLogoMobileIcon width='40px' />;
};

export default AppLogoMobile;
